import { Badge, Tag } from '@chakra-ui/react';

const statusColors = {
  1: 'green',
  2: 'orange',
  3: 'purple',
  4: 'lightblue',
  5: 'gray',
  6: 'cyan',
  7: 'blue',
  8: 'red',
  9: 'yellow',
  10: 'yellow',
  11: 'yellow',
};

export const Status = ({ status, size = 'sm' }: { status?: EntityBase, size?: 'sm' | 'md' }) => {
  if (!status) {return <></>;}
  return <Badge 
    colorScheme={statusColors[status.id]} 
    fontSize={10}
    px={size === 'md' ? 3 : 1}
    py={size === 'md' ? 2 : 0}
  >
    {status.name}
  </Badge>;
};